import { GoogleMapsAPIWrapper } from '@agm/core';
import { Directive, Input, Output, OnChanges, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { Route, TourPlan, ShowCode, Customer, Parameters, SectionType, MeetingDisplayItem, VisitFilterType,  VisitSelectionEvent, VisitEventType } from './model/model.class';
import { Labels } from './model/language.model.class';
import { SharedService } from "./shared.service";
import { ComponentRef, Injector, ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef } from '@angular/core';
import { MeetingInfoComponent } from './meeting-info.component';
declare var google: any;

@Directive({
  selector: 'agm-directions'
})
export class DirectionsMapDirective implements OnChanges {
  @Input() tourPlan: TourPlan;
  @Input() showCodeValue: number;
  @Input() isUserChecked: any;
  @Output() onRouteChange: EventEmitter<Route> = new EventEmitter<Route>();
  @Input() labels: Labels;


  selectedVisitOptions: VisitSelectionEvent = {
    allOptions: [
      { key: VisitFilterType.ShowUserPosition.toString(), selected: true, visible :true },
      { key: VisitFilterType.Outcome.toString(), selected: false, visible: true },
      { key: VisitFilterType.Oneshot.toString(), selected: true, visible: true },
      { key: VisitFilterType.Booster.toString(), selected: true, visible: true },
      { key: VisitFilterType.Priority.toString(), selected: true, visible: true },
    ],
    lastChanged: null
  };

  constructor(
    private gmapsApi: GoogleMapsAPIWrapper,
    private sharedService: SharedService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  directionsDisplay: any;
  markerList = new Route();
  showCode = ShowCode;
  openInfoWindow: any = null;

  duration = 0;
  distance = 0;

  ngOnChanges(event) {
    this.refresh(event)

  }

  refresh(event) {
    
    if (event.tourPlan != undefined) {


      this.gmapsApi.getNativeMap().then(map => {

        this.deleteMarkers();

        if (!this.tourPlan) return;

        var stepDisplay = new google.maps.InfoWindow;

        if (this.tourPlan.TrackingPoints && this.tourPlan.TrackingPoints.length > 0 && this.isUserChecked) {
          this.setTrackingPointsMarker(map, stepDisplay);
        }

        if (!this.tourPlan.PlanOfDay.Customers || this.tourPlan.PlanOfDay.Customers.length == 0) {
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(0, 0),
            title: this.labels.BarComponent["NothingToday"],
            icon: "https://maps.google.com/mapfiles/ms/micons/info.png"
          });
          this.markerList.dailyMeetingMarkers.push(marker);
          this.markerList.homeMarkers.push(marker);
          this.onRouteChange.emit(this.markerList);
          
          return;
        }

        var customers = this.tourPlan.PlanOfDay.Customers;

        if (!this.isSelected(VisitFilterType.Oneshot)) {
          // escludo sia i oneshot che le calllist(origin=200)
          customers = customers.filter(
            c => !(
              (String(c.Origin) === "0" && String(c.EventType) === "0") ||
              (String(c.Origin) === "0" && String(c.EventType) === "300") ||
              (String(c.Origin) === "200")
            )
          );
        }

        if (!this.isSelected(VisitFilterType.Booster)) {
          customers = customers.filter(c => !(String(c.Origin) === "400"));
        }

        if (!this.isSelected(VisitFilterType.Priority)) {
          customers = customers.filter(c => !(String(c.Origin) === "300"));
        }

        const dailyMeetingCustomers = customers.filter(c => (c.Type === 1 && c.CustomerId != null) || ((c.Type === 2 || c.Type === 3) && c.CustomerId != null));
        const homeAddress = customers.filter(c => c.Type === 4 && c.CustomerId == null);
        const endAddress = customers.filter(c => c.Type === 5 && c.CustomerId == null);

        if (homeAddress.length > 0) dailyMeetingCustomers.unshift(homeAddress[0]);
        if (endAddress.length > 0) dailyMeetingCustomers.push(endAddress[0]);

        this.directionsDisplay.setMap(map);

        this.directionsDisplay.setOptions({
          polylineOptions: {
            strokeWeight: 8,
            strokeOpacity: 0.7,
            strokeColor: '#00468c'
          }
        });

        this.directionsDisplay.setDirections({ routes: [] });

        const directionsService = new google.maps.DirectionsService;
        const me = this;

        // just to preserve the original logic: include in the route recurring visits and one shot visits (just the real one!)
        let visits = dailyMeetingCustomers.concat(dailyMeetingCustomers.filter(c => c.Type === 2));

        // Filter all visits referring to Customers with Latitude and Longitute <> 0
        visits = visits.filter(c => String(c.Latitude) !== "0" && String(c.Longitude )!== "0");

        // Calculate the route among the various visits using the google api
        if (visits.length > 0) {
          const quotient = Math.floor((visits.length) / 23);
          const remainder = (visits.length) % 23;

          for (let q = 0; q <= quotient; q++) {
            const waypts = [];

            const index = q == 0 ? 23 * q : (23 * q) - 1;
            const lastIndex = (q == quotient ? (23 * q) + remainder : (23 * q) + 23) - 1;

            const latLngA = new google.maps.LatLng(visits[index].Latitude, visits[index].Longitude);
            const latLngB = new google.maps.LatLng(visits[lastIndex].Latitude, visits[lastIndex].Longitude);

            for (let i = index; i < lastIndex; i++) {
              const location = new google.maps.LatLng(visits[i].Latitude, visits[i].Longitude);
              waypts.push({
                location: location,
                stopover: true
              });
            }

            directionsService.route({
              origin: latLngA,
              destination: latLngB,
              waypoints: waypts,
              optimizeWaypoints: false,
              avoidHighways: false,
              travelMode: google.maps.DirectionsTravelMode.DRIVING
            }, function (response: any, status: any) {
              if (status === 'OK') {
                me.directionsDisplay.setDirections(response);
                map.setZoom(30);
                me.markerList.Estimated = me.GetEstimated(response.routes[0]);
                me.onRouteChange.emit(me.markerList);
              } else {
                console.log('Directions request failed due to ' + status);
              }
            });
          }
        }
        me.showSteps(map, stepDisplay, dailyMeetingCustomers);
      });
    }
  }

  private GetEstimated(route) {
    route.legs.forEach(leg => {
      this.duration += leg.duration.value;
      this.distance += leg.distance.value;
    });

    var hours = Math.floor(this.duration / 3600);
    var minutes = Math.floor((this.duration - (hours * 3600)) / 60);
    var seconds = this.duration - (hours * 3600) - (minutes * 60);
    var hoursText = hours.toString();
    var minutesText = minutes.toString();
    var secondsText = seconds.toString();
    if (hours < 10) { hoursText = "0" + hours; }
    if (minutes < 10) { minutesText = "0" + minutes; }
    if (seconds < 10) { secondsText = "0" + seconds; }
    var durationText = hoursText + ':' + minutesText + ':' + secondsText;

    var distanceText = Math.round(this.distance / 1000) + ' Km';

    return durationText + ' (' + distanceText + ')';
  }


  private showSteps(map, stepDisplay, dailyMeetingCustomers: Customer[]) {
    

    if (dailyMeetingCustomers.length > 0) {
      // this value is used to build the icon for the recurring appointments on the map
      let iconIndex = 0;
      let iLetter = -1;
      for (let i = 0; i < dailyMeetingCustomers.length; i++) {
        const dailyMeetingCustomer = dailyMeetingCustomers[i];
        
        const location = new google.maps.LatLng(dailyMeetingCustomer.Latitude, dailyMeetingCustomer.Longitude)
        var visible = this.showPointMaps(dailyMeetingCustomers, i);
        // the visit is the start point or the end point of the tour: we have dedicated icons and title for the google marker
        if (dailyMeetingCustomer.Type === 4 || dailyMeetingCustomer.Type === 5) {
          const title = this.labels.Customer[dailyMeetingCustomer.Type];
          const iconLink = dailyMeetingCustomer.Type === 4 ? "https://maps.google.com/mapfiles/kml/pal2/icon10.png" : "https://maps.google.com/mapfiles/kml/pal2/icon13.png";

          const marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: iconLink,
            animation: google.maps.Animation.DROP,
            title: title
          });

          this.markerList.homeMarkers.push(marker);
          continue;
        }

        var isPlanned = dailyMeetingCustomer.Type == 1 ? true : false; // To ckeck if dailymeeting is 'Planned' or 'Oneshot'

        // if we are at this point, the visit is a real recurring visit: we build the google marker with the right icon and title
        iconIndex++;
        const showReport = dailyMeetingCustomer.Outcomes != null && dailyMeetingCustomer.Outcomes.length > 0;
        const iconBG = showReport && (this.showCodeValue & this.showCode.reports) == this.showCode.reports ? this.sharedService.getColorVisitOutcome(dailyMeetingCustomer.Outcomes[0]) : "";
        const marker = new google.maps.Marker({
          position: location,
          map: map,
          visible: visible,
          icon: this.sharedService.getMarkerIcon({ background: iconBG, eventType: dailyMeetingCustomer.EventType, origin: dailyMeetingCustomer.Origin }),
          label: this.sharedService.getMarkerLabel(dailyMeetingCustomer.Position, dailyMeetingCustomer.FixedStartDate),
          animation: google.maps.Animation.DROP,
          title: dailyMeetingCustomer.Name,
          outcome: showReport,
          outcomeId: dailyMeetingCustomer.Outcomes && dailyMeetingCustomer.Outcomes.length > 0 ? dailyMeetingCustomer.Outcomes[0] : null
        });
        (marker as any).name1 = dailyMeetingCustomer.Name1;
        (marker as any).name2 = dailyMeetingCustomer.Name2;
        (marker as any).customerid = dailyMeetingCustomer.CustomerId;
        (marker as any).origin = dailyMeetingCustomer.Origin;
        (marker as any).eventType = dailyMeetingCustomer.EventType;
        (marker as any).isPhoneCall = dailyMeetingCustomer.IsPhoneCall;
        (marker as any).fixedStartDate = dailyMeetingCustomer.FixedStartDate;
        (marker as any).duration = dailyMeetingCustomer.Duration;
        this.markerList.dailyMeetingMarkers.push(marker);
        if (isPlanned)
          this.markerList.recurringMarkers.push(marker);
        else
          this.markerList.oneShotMarkers.push(marker);

        const customerText = [];
        if (dailyMeetingCustomer.MainCustomerId != null) {
          customerText.push("<img alt='' src='https://maps.google.com/mapfiles/ms/micons/truck.png' style='vertical-align: bottom; height: 20px;' />");
          customerText.push(dailyMeetingCustomer.Name);
          customerText.push("ID: " + dailyMeetingCustomer.CustomerId + " (" + dailyMeetingCustomer.MainCustomerId + ")");
        } else {
          customerText.push(dailyMeetingCustomer.Name);
          customerText.push("ID: " + dailyMeetingCustomer.CustomerId);
        }
        customerText.push(this.labels.Customer[dailyMeetingCustomer.Type]);
        let outcome = "";
        if (showReport) {
          outcome = Array.from(dailyMeetingCustomer.Outcomes, o => this.labels.Outcome[o]).join(",");
          customerText.push("Outcome: " + outcome);           
        }

        let text = customerText.join("<br/>");

        let meetingItem: MeetingDisplayItem = {
          name1: dailyMeetingCustomer.Name1,
          name2: dailyMeetingCustomer.Name2,
          customerId: dailyMeetingCustomer.CustomerId,
          origin: dailyMeetingCustomer.Origin,
          eventType: dailyMeetingCustomer.EventType,
          isPhoneCall: dailyMeetingCustomer.IsPhoneCall,
          visitRule: dailyMeetingCustomer.VisitRule,
          outcome: outcome,
          icon_on_top_left: '',
          icon_on_bottom_left: '',
          fixedStartDate: dailyMeetingCustomer.FixedStartDate,
          duration: dailyMeetingCustomer.Duration,
          customerState: dailyMeetingCustomer.CustomerState,
          priority: dailyMeetingCustomer.Priority

        };

        meetingItem = this.sharedService.getMeetingPointPopup(meetingItem)

        this.attachInstructionText(marker, meetingItem, map, stepDisplay);

      }
    } else {
      // we don't have recurring appointments - create a special marker for this particular situation
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(0, 0),
        title: this.labels.BarComponent["NoRecurring"],
        icon: "https://maps.google.com/mapfiles/ms/micons/info.png"
      });
      this.markerList.recurringMarkers.push(marker);
    }
  }

  private showPointMaps(mapPoints: Customer[], currentIndex: number): boolean {
    const mapPoint = mapPoints[currentIndex];
    for (let i = 0; i < currentIndex; i++) {
      const prevPoint = mapPoints[i];
      if (
        (prevPoint.Latitude === mapPoint.Latitude &&
          prevPoint.Longitude === mapPoint.Longitude) ||
        prevPoint.CustomerId === mapPoint.CustomerId
      ) {
        return false; 
      }
    }
    return true; 
  }


  private setTrackingPointsMarker(map, stepDisplay) {
    let that = this;
    let trackingPoints: any = that.tourPlan.TrackingPoints;
    let dateTimeInterval;

    if (trackingPoints && trackingPoints.length > 0) {
      dateTimeInterval = new Date(trackingPoints[0].Time.match(/\d+/)[0] * 1);
    }

    let maxLength = trackingPoints.length - 1;
    for (var i = 0; i < trackingPoints.length; i++) {
      let iconLink = "";
      let iconObj = {};
      let title = "";
      let marker;

      let futuredateTimeInterval =
        dateTimeInterval.getTime() + (30 * 60 * 1000);
      let currentDate =
        new Date(trackingPoints[i].Time.match(/\d+/)[0] * 1);
      let currentDateTime =
        currentDate.getTime();

      if (iconLink == "" && i != 0 && currentDateTime >= futuredateTimeInterval) {

        dateTimeInterval = new Date(trackingPoints[i].Time.match(/\d+/)[0] * 1);

        marker = new google.maps.Marker({
          map: map,
          animation: google.maps.Animation.DROP
        });

        let prevPosn = new google.maps.LatLng(trackingPoints[i - 1].Latitude, trackingPoints[i - 1].Longitude);
        marker.setPosition(
          new google.maps.LatLng(
            trackingPoints[i].Latitude,
            trackingPoints[i].Longitude
          )
        );

        marker.setIcon({
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          strokeColor: 'DimGrey',
          //strokeWeight: 3,
          //scale: 6,
          ////  flat: true,
          scale: 3,
          rotation: google.maps.geometry.spherical.computeHeading(prevPosn, marker.getPosition())
        });

        this.attachInstructionText(marker, map, stepDisplay, 
				   currentDate.getHours() + ":" + currentDate.getMinutes());
      }
      else if (i == maxLength) {
        iconLink = "https://maps.google.com/mapfiles/arrow.png";
        title = "Last position";

        var location = new google.maps.LatLng(trackingPoints[i].Latitude, trackingPoints[i].Longitude);
        marker = new google.maps.Marker({
          position: location,
          map: map,
          icon: iconLink,
          animation: google.maps.Animation.DROP
        });

      }

      if (marker) {
        marker.setVisible((that.showCodeValue & that.showCode.user) == that.showCode.user);
        that.markerList.userMarkers.push(marker);

        //google.maps.event.trigger(marker, 'click');
      }
    }
  }

  private clearMarkers(markers) {
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
  }

  private deleteMarkers() {
    this.clearMarkers(this.markerList.dailyMeetingMarkers);
    this.clearMarkers(this.markerList.recurringMarkers);
    this.clearMarkers(this.markerList.homeMarkers);
    this.clearMarkers(this.markerList.oneShotMarkers);
    this.clearMarkers(this.markerList.userMarkers);
    this.markerList.dailyMeetingMarkers = [];
    this.markerList.recurringMarkers = [];
    this.markerList.homeMarkers = [];
    this.markerList.oneShotMarkers = [];
    this.markerList.userMarkers = [];
    this.duration = 0;
    this.distance = 0;
    this.markerList.Estimated = "";
    this.onRouteChange.emit(this.markerList);
    this.directionsDisplay.setDirections({ routes: [] });
  }



  private attachInstructionText(marker: any, item: MeetingDisplayItem, map: any, stepDisplay: any) {
    const factory = this.componentFactoryResolver.resolveComponentFactory(MeetingInfoComponent);
    const componentRef = factory.create(this.injector);

    componentRef.instance.item = item;
    componentRef.instance.showCloseButton = true;

    const infoWindow = new google.maps.InfoWindow();
    componentRef.instance.close.subscribe(() => {
      infoWindow.close();
    });

    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;

    marker.addListener('click', () => {

      this.sharedService.isVendorPopupVisible = false;
      if (this.openInfoWindow) {
        this.openInfoWindow.close();
      }

      infoWindow.setContent(domElem);
      infoWindow.open(map, marker);

      this.openInfoWindow = infoWindow;

      google.maps.event.addListenerOnce(infoWindow, 'domready', () => {

        const iwOuter = domElem.closest('.gm-style-iw') as HTMLElement;

        if (iwOuter) {
          const iwChr = iwOuter.querySelector('.gm-style-iw-chr') as HTMLElement;
          if (iwChr) {
            iwChr.style.display = 'none';
          }

          const closeBtn = iwOuter.querySelector('.gm-ui-hover-effect') as HTMLElement;
          if (closeBtn) {
            closeBtn.setAttribute('tabindex', '-1');
            closeBtn.blur();
          }
        }
      });
    });

    google.maps.event.addListener(infoWindow, 'closeclick', () => {
      this.openInfoWindow = null;
    });

  }

  private getcomputeDistance(latLngA: any, latLngB: any) {
    return (google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB) / 1000).toFixed(2);
  }

  onVisitFilterChanged(event: VisitSelectionEvent) {
    this.selectedVisitOptions = event;
    const lastChanged = event.lastChanged;

    const changes: SimpleChanges = {
      tourPlan: new SimpleChange(null, this.tourPlan, false),
      showCodeValue: new SimpleChange(null, this.showCodeValue, false),
      isUserChecked: new SimpleChange(null, this.isUserChecked, false)
    };

    this.refresh(changes);
  }

  isSelected(filter: VisitFilterType): boolean {
    const option = this.selectedVisitOptions.allOptions.find(o => o.key === filter.toString());
    return option ? option.selected : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/map.directive.ts